import React, { createContext, useState, useEffect, useContext } from 'react';
import apiClient from '../api/apiClient';
import { secToHourMin } from '../utils/utils';
import { useLogin } from './LoginContext';
import { useCourse } from './CourseContext';
import { useNavigate } from 'react-router-dom';
import { USERCONTENTPROGRESS, COURSELESSONPROGERSS, GETCOURSELIST } from '../utils/ApiEndPoint';



export const LessonContext = createContext();

export const LessonProvider = ({ children, courseId }) => {
    const navigate = useNavigate();
    const { getCourseDteatilById, userCourse } = useCourse();
    const { user, logout, isLoggedIn } = useLogin();
    const [courseDetail, setCourseDetail] = useState({});
    const [lessons, setLessons] = useState([]);
    const [activeIdx, setActiveIdx] = useState(null);
    const [lastPosition, setLastPosition] = useState(0);
    const [lessonProgress, setLessonProgress] = useState(null);
    // //check if user is logged in or not when courseId changes
    useEffect(() => {
        if (!isLoggedIn) {
            reset();
            return;
        }
    }, [isLoggedIn]);
    // Fetch lesson progress when courseId or user changes
    useEffect(() => {
        if (!userCourse.length || !courseId || !user?.lmsRoles || !user?.selectedRole) return;
        const getCourseLessonProgress = () => {
            apiClient.get(`${COURSELESSONPROGERSS}/?userId=${user?.userId}&courseId=${courseId}`)
                .then((response) => {
                    if (response.status === 200) {
                        setLessonProgress(response.data.progress || []);
                    }
                }).catch(() => {

                });
        };
        getCourseLessonProgress();
    }, [courseId, user?.lmsRoles, user?.selectedRole, userCourse]);
    // Fetch course details when courseId or lessonProgress changes
    useEffect(() => {
        if (!courseId || !lessonProgress || !user?.selectedRole) return;
        const fetchCourseDetail_learner = async () => {
            const courseDetail = getCourseDteatilById(courseId);
            if (courseDetail !== null) {
                const modules = courseDetail?.modules ? JSON.parse(courseDetail?.modules) : [];
                const lessons = modules[0]?.lessons ? JSON.parse(modules[0]?.lessons) : [];
                const videoLesson = lessons?.filter(lesson => lesson.type.toLowerCase() === "video");
                const quizeLesson = lessons?.filter(lesson => lesson.type.toLowerCase() === "quiz");
                setCourseDetail({
                    _id: courseId,
                    title: courseDetail.title,
                    description: courseDetail.description,
                    status: courseDetail.status,
                    refDoc: lessons?.filter(lesson => lesson.type.toLowerCase() === "ref_doc"),
                    videoLength: videoLesson.length,
                    assessmentLength: quizeLesson.length,
                    remarks: courseDetail.remarks,
                    createdAt: courseDetail.createdAt,
                    courseDuration: getCourseDuration(videoLesson),
                    ratingdata: courseDetail.ratingdata,
                    courseRatingSummary: courseDetail.courseRatingSummary
                });
                lessonWithProgress([...videoLesson, ...quizeLesson]);
            } else {
                console.log('no course found')
            }
        };
        const fetchCourseDetail = () => {
            const courseDetail = getCourseDteatilById(courseId);
            apiClient.get(`${GETCOURSELIST}/${courseId}`)
                .then((response) => {
                    if (response.status === 200) {
                        const videoLesson = response.data?.modules[0]?.lessons?.filter(lesson => lesson.type.toLowerCase() === "video");
                        const quizeLesson = response.data?.modules[0]?.lessons?.filter(lesson => lesson.type.toLowerCase() === "quiz");
                        const refDoc = response.data?.modules[0]?.lessons?.filter(lesson => lesson.type.toLowerCase() === "ref_doc");
                        const duration = getCourseDuration(videoLesson);
                        setCourseDetail({
                            _id: courseId,
                            title: response.data.title,
                            description: response.data.description,
                            status: response.data.status,
                            refDoc: refDoc,
                            videoLength: videoLesson.length,
                            assessmentLength: quizeLesson.length,
                            remarks: response.data.remarks,
                            createdAt: response.data.createdAt,
                            courseDuration: duration,
                            ratingdata: courseDetail.ratingdata,
                            courseRatingSummary: courseDetail.courseRatingSummary
                        });
                        lessonWithProgress([...videoLesson, ...quizeLesson]);
                    } else {
                        console.error(`Failed to fetch course details: ${response.statusText}`);
                    }
                })
                .catch((e) => {
                    console.error("Error fetching course details", e);
                }).finally(() => {
                });
        };
        // if (user.selectedRole === "viewer") {
        //     fetchCourseDetail_learner();
        // } else {
            fetchCourseDetail();
        // }

    }, [courseId, lessonProgress, user]);
    // Calculate total course duration from video lessons
    const getCourseDuration = (courseVideo) => {
        let courseDuration = '0 min';
        if (courseVideo?.length > 0) {
            courseDuration = courseVideo.reduce((total, lesson) => {
                return total + (lesson?.refDetails?.duration || 0);
            }, 0);
            courseDuration = secToHourMin(courseDuration);
        }
        return courseDuration;
    }
    // Combine lesson details with user progress
    const lessonWithProgress = (videoAndQuizeLesson) => {
        const templesson = videoAndQuizeLesson.map(lesson => {
            console.log("🚀 krishna  ~ lesson:", lesson);

            const progress = lessonProgress.find(p => p.contentId === lesson.refId);
            console.log("🚀 krishna  ~ progress:", progress);

            if (progress) {
                return {
                    ...lesson,
                    lastPosition: progress?.lastPosition || 0,
                    status: progress?.status || 'not_started',
                    contentType: progress?.contentType || lesson?.type?.toLowerCase(),
                    totalDuration: progress?.totalDuration || lesson?.refDetails?.duration || 0,
                    completedAt: progress?.completedAt,
                    updatedAt: progress?.updatedAt,
                };
            } else {
                return {
                    ...lesson,
                    lastPosition: 0,
                    status: 'not_started',
                    contentType: lesson?.type?.toLowerCase(),
                    totalDuration: lesson?.refDetails?.duration || 0,
                    completedAt: null,
                    updatedAt: null,
                };
            }
        });
        setLessons(templesson);
        getActiveLesson(templesson);
    };
    // Determine the active lesson based on progress and set the last position for video lessons
    const getActiveLesson = (templesson) => {
        const lastUpdate = [...templesson].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))[0];
        let lastLessonIndex = 0;
        if (lastUpdate) {
            if (lastUpdate.status !== "completed" || (lastUpdate.totalDuration > 0 && lastUpdate.lastPosition < lastUpdate.totalDuration)) {
                // console.log(lastUpdate,'------------------1-------------',templesson)
                lastLessonIndex = templesson.findIndex(lesson => lesson?.refDetails?._id === lastUpdate?.refId);
            } else {
                //  console.log('------------------2-------------')
                lastLessonIndex = templesson.findIndex(lesson => lesson?.status === 'not_started' || lesson?.status === 'in_progress' || lesson?.status === 'failed' || lesson?.status === '');
            }
        }
        // console.log("🚀 krishna  ~ lastLessonIndex:", lastLessonIndex);
        setActiveIdx(lastLessonIndex > -1 ? lastLessonIndex : 0);// Set to the next lesson if available
        if (templesson[lastLessonIndex]?.contentType === "video") {
            setLastPosition(Math.floor(templesson[lastLessonIndex]?.lastPosition) || 0);
        }
    }
    // Get the next lesson based on the user's role and lesson status, and update the active index accordingly
    const getnextLesson = (couldChangeLesson = true) => {
        // console.log("🚀 krishna  ~ getnextLesson ~ activeIdx:", activeIdx);
        if (user.selectedRole === "viewer") {
            const nextActiveLesson = lessons.findIndex(lesson => lesson?.status === 'not_started' || lesson?.status === 'in_progress' || lesson?.status === 'failed' || lesson?.status === '');
            // console.log("🚀 krishna  ~ nextActiveLesson:", nextActiveLesson);
            if (nextActiveLesson === -1) {
                // console.warn("No next lesson available.");
                return nextActiveLesson; // No next lesson available, return current index
            }
            couldChangeLesson && setActiveIdx(nextActiveLesson);
            return nextActiveLesson;
        }
        else {
            let nextActiveLesson = activeIdx;
            nextActiveLesson = nextActiveLesson + 1;
            if (nextActiveLesson < lessons.length) {
                setActiveIdx(nextActiveLesson);
                setLastPosition(0);
            }
            return nextActiveLesson;
        }

    };
    // Update the lesson progress in the local state and send the tracking data to the server
    const updateLessonProgres = (payload) => {
        const updatedLessons = lessons.map(lesson => {
            if (lesson.refDetails._id === payload.contentId) {
                return {
                    ...lesson,
                    lastPosition: payload.lastPosition,
                    status: payload.status,
                    totalDuration: payload.totalDuration,
                    completedAt: payload.completedAt,
                    updatedAt: new Date().toISOString(),
                };
            }
            return lesson;
        });
        // console.log("🚀 krishna  ~ updatedLessons:", updatedLessons[2].lastPosition);

        setLessons(updatedLessons);
    }
    const TrackLessonView = (contentType, eventType, extraData = {}) => {
        let payload = {
            "userId": user?.userId,
            "courseId": courseDetail?._id,
            "contentId": lessons[activeIdx]?.refDetails?._id,
            "contentType": contentType,// "video" | "quiz" | "lesson" | "doc"
        }
        if (user.selectedRole !== "viewer") return;
        if (contentType == 'video') {
            const percentage = extraData?.currentTime ? (extraData.currentTime / extraData.duration) * 100 : 0;
            const status = percentage >= 90 || lessons[activeIdx]?.status === 'completed' ? "completed" : "in_progress";
            payload['status'] = status; // "not_started" | "in_progress" | "completed"
            payload["lastPosition"] = extraData?.currentTime || 0,// seconds (for video/audio)
                payload["totalDuration"] = extraData?.duration, // seconds (for video/audio)
                payload["completedAt"] = (eventType === 'video_ended' || percentage >= 90) ? new Date().toISOString() : null;
        } else if (contentType == 'quiz') {
            const percentage = extraData?.score ? (extraData.score / extraData.maxScore) * 100 : 0;

            const status = percentage >= 60 || lessons[activeIdx]?.status === 'completed' ? "completed" : "failed";
            payload['status'] = status;
            payload["lastPosition"] = extraData?.score,// seconds (for video/audio)
                payload["totalDuration"] = extraData?.maxScore, // seconds (for video/audio)
                payload["completedAt"] = new Date().toISOString();
        }

        updateLessonProgres(payload);

        return apiClient.post(USERCONTENTPROGRESS, payload).then((response) => {
            if (response.status === 200) {
            } else {
                console.error("Failed to send tracking data:", response.statusText);
                logout(() => {
                    navigate('/');
                });
            }
        }).catch((error) => {
            console.error("Error sending tracking data:", error);
            logout(() => {
                navigate('/');
            });
        });
    };
    // Change the active lesson based on the provided index and update the last position for video lessons accordingly
    const changeActiveLesson = (index) => {
        // console.log("🚀 krishna  ~ index:", index);

        if (index < 0 || index >= lessons.length) {
            console.error("Invalid lesson index:", index);
            return;
        }
        setActiveIdx(index);
        // console.log(lessons[index])
        lessons[index]?.contentType === "video" && lessons[index]?.lastPosition < lessons[index]?.totalDuration ?
            setLastPosition(Math.floor(lessons[index].lastPosition) || 0) :
            setLastPosition(0);
        // setLastPosition(Math.floor(lessons[index].lastPosition) || 0);
    };
    // Reset the lesson context state to its initial values
    const reset = () => {
        setCourseDetail({});
        setLessons([]);
        setActiveIdx(null);
        setLastPosition(0);
        setLessonProgress(null);
    }
    // Reset the lesson context state whenever the course ID changes to ensure that the new course data is loaded correctly
    useEffect(() => {
        return () => {
            reset();
        }
    }, [courseId]);
    // Provide the lesson context values to the child components
    return (
        <LessonContext.Provider
            value={{
                courseDetail,
                lessons,
                getnextLesson,
                activeIdx,
                lastPosition,
                TrackLessonView,
                changeActiveLesson,
            }}
        >
            {children}
        </LessonContext.Provider>
    );
};

export const useLesson = () => useContext(LessonContext);